const BASE = "/api/v1";

let _csrf = "";
export function setCsrf(token: string) { _csrf = token; }
export function getCsrf() { return _csrf; }

async function req<T>(method: string, path: string, body?: unknown, extraHeaders?: Record<string, string>): Promise<T> {
  const headers: Record<string, string> = { "Content-Type": "application/json", ...extraHeaders };
  if (method !== "GET" && _csrf) headers["x-csrf-token"] = _csrf;
  const init: RequestInit = { method, headers, credentials: "include" };
  if (body !== undefined) init.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, init);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw Object.assign(new Error(err.message || res.statusText), { status: res.status, data: err });
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export const api = {
  get: <T>(path: string) => req<T>("GET", path),
  post: <T>(path: string, body?: unknown, extraHeaders?: Record<string, string>) => req<T>("POST", path, body, extraHeaders),
  put: <T>(path: string, body?: unknown, extraHeaders?: Record<string, string>) => req<T>("PUT", path, body, extraHeaders),
  patch: <T>(path: string, body?: unknown, extraHeaders?: Record<string, string>) => req<T>("PATCH", path, body, extraHeaders),
  // DELETE without body — omit Content-Type so Fastify doesn't try to parse an empty JSON body
  delete: <T>(path: string): Promise<T> => {
    const headers: Record<string, string> = {};
    if (_csrf) headers["x-csrf-token"] = _csrf;
    return fetch(`${BASE}${path}`, { method: "DELETE", headers, credentials: "include" }).then(async res => {
      if (!res.ok) {
        const err = await res.json().catch(() => ({ message: res.statusText }));
        throw Object.assign(new Error((err as { message?: string }).message || res.statusText), { status: res.status, data: err });
      }
      if (res.status === 204) return undefined as T;
      return res.json() as Promise<T>;
    });
  },
};
